import * as React from 'react'

import { config } from '../../../../../common/config'
import { ILocationParams } from '../../../../../common/reducers/reactRouterLocation'

import DidYouMeanBy from '../../../../shared/components/searchResultHeaders/didYouMeanBy'

import {
  activeFiltersParams,
  queryWithoutFilters
} from '../../../../../common/utils/urlHelper'

import SearchLink from '../../../../shared/containers/searchLinkContainer'

import * as didYouMeanLinkStyles from './didYouMeanLink.module.css'
import * as styles from './searchNoResults.module.css'

interface IProps {
  locationParams: ILocationParams
  didYouMeanByTerms: string[]
}

const SearchNoResults: React.StatelessComponent<IProps> = props => {
  const renderClearFiltersLink = () => {
    const link = (
      <SearchLink
        locationParams={queryWithoutFilters(locationParams)}
        className={styles.clearFilterLink}
      >
        clearing some filters
      </SearchLink>
    )

    return <span>Try {link} and try again.</span>
  }

  const { locationParams, didYouMeanByTerms } = props
  const hasActiveFilters = activeFiltersParams(locationParams).length

  return (
    <div className={styles.searchNoResults}>
      <div>
        <img
          alt={''}
          role="presentation"
          src={`${config.assets.PUBLIC_PATH}/images/saucer.png`}
          className={styles.flyingSaucer}
        />
      </div>
      <div>
        <h2 className={styles.searchNoResultsHeading}>
          {hasActiveFilters || didYouMeanByTerms.length === 0 ? (
            'Nothing exists here'
          ) : (
            <DidYouMeanBy {...props} styles={didYouMeanLinkStyles} />
          )}
        </h2>
        <p className={styles.searchNoResultsSubHeading}>
          {"We couldn't find any results for your search. "}
          {hasActiveFilters
            ? renderClearFiltersLink()
            : 'Use more generic words or double check your spelling.'}
        </p>
      </div>
    </div>
  )
}

export default SearchNoResults
